module.exports = __webpack_public_path__ + "img/ogp_l-vk_big.8c79dde2.jpg";